import { useRequest } from "../../../hooks/useRequest";
import { useState } from "react";
import useHttpResponseAlert from "../../../hooks/useHttpResponseAlert";
import { FormikValues } from "formik";
import Utils from "../utils";
import { ApiOutcome } from "../types";
import routes from "../../../routes";

export function useUpdateSolutionDetails(id: string) {
  const [isEditing, setEditing] = useState(false);

  const { fetch, response, error, loading } = useRequest();

  const { alert, setAlert } = useHttpResponseAlert(
    error,
    response,
    "Project has been updated successfully!",
  );

  const handleSubmit = async (form: FormikValues) => {
    const updatePayload = Utils.SolutionFormBuilder.updateSolution(form);
    const existingOutcomesV2 = (form["outcomes-v2"] || []) as Array<ApiOutcome>;
    const outcomesV3 = updatePayload.outcomes || [];
    const { outcomes: _outcomes, ...payloadWithoutOutcomes } = updatePayload;
    const normalisedPayload = {
      ...payloadWithoutOutcomes,
      outcomes: {
        v2: outcomesV3.length > 0 ? outcomesV3 : existingOutcomesV2,
        v3: outcomesV3,
      },
    };
    const geojsonFile = normalisedPayload?.riskMonitoring?.geospatialFile;
    const url = routes.api.solution.individual({ id });

    let result;
    if (!(geojsonFile instanceof File)) {
      result = await fetch("PATCH", url, normalisedPayload);
    } else {
      const multipartForm = new FormData();
      const solutionMetadata = {
        ...normalisedPayload,
        riskMonitoring: {
          ...normalisedPayload.riskMonitoring,
          geospatialFile: null,
        },
      };
      multipartForm.set("payload", JSON.stringify(solutionMetadata));
      multipartForm.set("file", geojsonFile, geojsonFile.name);
      result = await fetch("PATCH", url, multipartForm, undefined, false);
    }

    if (result && result.status === 204) {
      setEditing(false);
    }

    return result;
  };

  return {
    loading,
    isEditing,
    setEditing,
    update: handleSubmit,
    alert,
    setAlert,
  };
}
